<template>
  <div>
    <Control :card="false" :icon="'mdi mdi-format-list-numbered'" :title="'Регламентированная отчетность, форма ' + fnoname" :links="links" :premium="true">
      <div class="form-inline float-right">
        <b-form-checkbox class="mr-sm-1" :value="1" :unchecked-value="0" v-model="params.paid">Заполнять графу "Выплачено доходов" суммами "К выплате"</b-form-checkbox>
        <b-form-checkbox class="mr-sm-1" :value="1" :unchecked-value="0" v-model="params.include_owner">Включать расчёты владельца ИП в отчёт</b-form-checkbox>
        <SelectOrg :name="'orgs'" :table="'reg_organizations'"
                   :fields="['name']" class="mr-sm-1"></SelectOrg>
        <template v-if="fnoperiod == 'halfyear'">
          <Enums class=" mr-sm-1" :type="'enum'" :name="'halfyears'" v-model="period.halfyear"></Enums>
        </template>
        <template v-if="fnoperiod == 'quarter'">
          <Enums class=" mr-sm-1" :type="'enum'" :name="'quarters'" v-model="period.quarter"></Enums>
        </template>
        <Enums class="mr-sm-1" :type="'enum'" :name="'years'" v-model="period.year"></Enums>
        <b-button class="mr-sm-1" size="sm" variant="primary" @click="Report">Сформировать отчет
        </b-button>
        <a @click="this.clearLink" class="btn btn-sm btn-success ml-sm-2" target="_blank" v-b-tooltip:hover title="Правой кнопкой мыши по данной кнопке и в появившемся меню нажмите СОХРАНИТЬ ССЫЛКУ КАК" download v-if="typeof result.link !== 'undefined' && result.link !== ''"
           :href="result.link">Скачать JSON файл</a>
      </div>
    </Control>

    <div class="container-fluid" v-if="user.registered && !user.subscribe_expired">
      <div v-if="typeof result.text !== 'undefined' && result.text !== ''" class="alert alert-success text-center">{{ result.text }}</div>
    </div>

    <Premium v-else />
  </div>

</template>


<script>
import SelectOrg from "@/components/base/SelectOrg";
import Enums from "@/components/base/Enums";
import Control from "@/components/base/ControlPanel";
import Premium from "@/components/base/Premium"
import {mapGetters} from "vuex";
export default {
  name: 'Form',
  components: {
    SelectOrg, Enums, Control, Premium
  },
  props: ['fnoname', 'fnoperiod', 'fnotitle'],
  data: function () {
    return {
      links: [
        {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
      ],
      params: {
        paid: 1,
        include_owner: 0
      },
      period: {
        year: new Date().getFullYear(),
        halfyear: 0,
        quarter: 0
      },
      result: {},
    }
  },
  methods: {
    Report: function () {
      this.result = {} // Обнуляем результат перед запросом
      this.$store.commit('wait', {state: true, name: 'Формирование отчета ' + this.fnoname});
      this.$http
          .post(this.$apiold, {
            task: 'fno',
            org: this.org,
            fno: {name: this.fnoname, period: this.fnoperiod},
            period: this.period,
            params: this.params
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            // Сообщения
            this.$store.commit('alert', response.data.messages);

            if (!response.data.error) {

              this.result = response.data.result;

            }
          })
    },
    clearLink: function () {

    }
  },
  computed: {
    ...mapGetters({
      org: 'org',
      user: "user"
    })
  },
  watch: {
    org: {
      handler: function () {
        if (this.org.mode == '1') {
          this.params.include_owner = 1;
        }
        else {
          this.params.include_owner = 0;
        }
      }
    }, deep: true
  },
  mounted() {
    if (this.org.mode == '1') {
      this.params.include_owner = 1;
    }
    else {
      this.params.include_owner = 0;
    }
  }
}
</script>